// RecentSessions.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getIconFileName } from "../utils/iconUtils";
import "../styles/PagesModern.css";
import { PageHeader, PanelHeader } from "./RefreshUI";

const RecentSessionsList = ({ setSearchId, searchId }) => {
        const [recentSessions, setRecentSessions] = useState(null);
        const [recentSessionsLoading, setRecentSessionsLoading] = useState(true);

        useEffect(() => {
                const fetchRecentSessions = async () => {
                        try {
                                const response = await axios.get(`https://iracing6-backend.herokuapp.com/api/sessionData/resultsrecent?limit=200`);
                                setRecentSessions(response.data);
                        } catch (error) {
                                console.error("Error fetching recent sessions:", error);
                        } finally {
                                setRecentSessionsLoading(false);
                        }
                };
                fetchRecentSessions();
        }, []);

        const navigate = useNavigate();

        const handleSessionClick = (subsession_id) => {
                window.location.href = `/RaceResults/${subsession_id}`;
        };

        const getIconUrl = (seasonName) => {
                const iconName = getIconFileName(seasonName);
                return `${process.env.PUBLIC_URL}/assets/series-icons/${iconName}.png`;
        };

        const formatTimeSince = (timeDiff) => {
                let minutes = Math.floor(timeDiff / 60000);
                let hours = Math.floor(minutes / 60);
                let days = Math.floor(hours / 24);

                if (days > 0) {
                        return `${days} ${days === 1 ? "day" : "days"} ago`;
                } else if (hours > 0) {
                        return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
                } else {
                        return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
                }
        };

        const uniqueSessionData = {};

        if (recentSessions) {
                recentSessions.forEach((session) => {
                        const key = `${session.start_time} - ${session.season_name}`;
                        if (!uniqueSessionData[key]) {
                                uniqueSessionData[key] = [];
                        }
                        uniqueSessionData[key].push(session);
                });
        }

        const renderSessions = () => {
                if (recentSessionsLoading) {
                        return <p className="hp-panel__note">Loading recent races…</p>;
                }
                if (!Object.keys(uniqueSessionData).length) {
                        return <p className="hp-panel__note">No recent races found.</p>;
                }
                return (
                        <ul className="pg-sessions">
                                {Object.entries(uniqueSessionData).map(([key, sessions]) => {
                                        const separatorIndex = key.indexOf(" - ");
                                        const startTime = key.substring(0, separatorIndex);
                                        const seasonName = key.substring(separatorIndex + 3);
                                        const timeSince = formatTimeSince(new Date() - new Date(startTime));
                                        return (
                                                <li key={key} className="pg-session">
                                                        <img src={getIconUrl(seasonName)} alt="" className="pg-session__icon" />
                                                        <div className="pg-session__info">
                                                                <span className="pg-session__name">{seasonName.replace(/\s*-?\s*\d{4} Season(\s+\d+)?/, "").trim()}</span>
                                                                <span className="pg-session__time">Started {timeSince}</span>
                                                        </div>
                                                        <div className="pg-session__splits">
                                                                {sessions
                                                                        .sort((a, b) => b.event_strength_of_field - a.event_strength_of_field)
                                                                        .map((session) => (
                                                                                <button
                                                                                        key={session.subsession_id}
                                                                                        type="button"
                                                                                        className="pg-split"
                                                                                        title={`Subsession ${session.subsession_id}`}
                                                                                        onClick={() => handleSessionClick(session.subsession_id)}
                                                                                >
                                                                                        SoF {session.event_strength_of_field?.toLocaleString()}
                                                                                </button>
                                                                        ))}
                                                        </div>
                                                </li>
                                        );
                                })}
                        </ul>
                );
        };

        const handleSearchChange = (e) => {
                setSearchId(e.target.value);
        };

        const handleSearchSubmit = () => {
                if (searchId) {
                        navigate(`/RaceResults/${searchId}`, { replace: true });
                }
        };

        return (
                <div className="pg">
                        <main className="hp-main">
                                <PageHeader title="Race results" lede="Open a race by its subsession ID, or pick one of the latest official races below.">
                                        <form
                                                className="pg-field__row"
                                                onSubmit={(e) => {
                                                        e.preventDefault();
                                                        handleSearchSubmit();
                                                }}
                                        >
                                                <label htmlFor="rr-search" className="hp-sr-only">
                                                        Subsession ID
                                                </label>
                                                <input id="rr-search" className="pg-input pg-input--wide" type="text" inputMode="numeric" value={searchId} onChange={handleSearchChange} placeholder="Subsession ID" />
                                                <button type="submit" className="pg-pager__btn">
                                                        Open race
                                                </button>
                                        </form>
                                </PageHeader>
                                <section className="hp-panel">
                                        <PanelHeader title="Recent races" />
                                        <p className="hp-panel__note">Each button is one split, with its strength of field.</p>
                                        {renderSessions()}
                                </section>
                        </main>
                </div>
        );
};

export default RecentSessionsList;
